import SC from 'styled-components'

export const Box = SC.div`
  padding: 27px 42px 35px 40px;
`

export const Footer = SC.div`
  display: flex;
`
